import { React, useState, useEffect } from "react";
import MainContainer from "../Components/MainContainer.js";
import { Accordion, Card } from "react-bootstrap";
import "../style/Home.css";
import { getUserActions, getCompletedUserActions } from "../Services/ReportingService.js";
import RemoveRequestDetailsModal from "../Components/RemoveRequestDetailsModal.js";
import PuffLoader from "react-spinners/PuffLoader";
import UpdateRequestDetailsModal from "../Components/UpdateRequestDetailsModal.js";
import AddUserRequestDetailsModal from "../Components/AddUserRequestDetailsModal.js";
import { isMobileScreen } from "../Util/Utils.js";
import UserRequestsAccordion from "../Components/UserRequestsAccordion.js";
import Notification from "../Components/Notification.js";

const RequestStatus = (props) => {
  const [currentRequest, setCurrentRequest] = useState(null);

  const [updatedRequest, setUpdatedRequest] = useState();
  const [requestIdBeingUpdated, setRequestIdBeingUpdated] = useState();

  const [incompleteUserActionsLoading, setIncompleteUserActionsLoading] = useState(true);
  const [completedUserActionsLoading, setCompletedUserActionsLoading] = useState(true);

  const [incompleteRemoveUserActions, setIncompleteRemoveUserActions] = useState([]);
  const [incompleteChangeUserActions, setIncompleteChangeUserActions] = useState([]);
  const [incompleteAddUserActions, setIncompleteAddUserActions] = useState([]);
  const [completedChangeUserActions, setCompletedChangeUserActions] = useState([]);
  const [completedAddUserActions, setCompletedAddUserActions] = useState([]);
  const [completedRemoveUserActions, setCompletedRemoveUserActions] = useState([]);

  const [showIncompleteRemoveUserRequestsDetailsModal, setShowIncompleteRemoveUserRequestsDetailsModal] =
    useState(false);
  const [showIncompleteChangeUserRequestsDetailsModal, setShowIncompleteChangeUserRequestsDetailsModal] =
    useState(false);
  const [showIncompleteAddUserRequestsDetailsModal, setShowIncompleteAddUserRequestsDetailsModal] = useState(false);
  const [showCompletedChangeUserRequestsDetailsModal, setShowCompletedChangeUserRequestsDetailsModal] = useState(false);
  const [showCompletedAddUserRequestsDetailsModal, setShowCompletedAddUserRequestsDetailsModal] = useState(false);
  const [showCompletedRemoveUserRequestsDetailsModal, setShowCompletedRemoveUserRequestsDetailsModal] = useState(false);

  // const crmUser = useSelector((state) => state.authentication.crmUser);
  const [isMobile, setIsMobile] = useState(isMobileScreen());

  useEffect(() => {
    getUserActions().then((response) => {
      if (response && response.removeRequests) {
        setIncompleteRemoveUserActions(response.removeRequests);
        setIncompleteUserActionsLoading(false);
        setIncompleteChangeUserActions(response.updateRequests);
        setIncompleteAddUserActions(response.addRequests);
      }
      setIsMobile(isMobileScreen());
      window.addEventListener("resize", setIsMobile(isMobileScreen()));
    });

    getCompletedUserActions().then((response) => {
      if (response && response.removeRequests) {
        setCompletedRemoveUserActions(response.removeRequests);
        setCompletedUserActionsLoading(false);
        setCompletedChangeUserActions(response.updateRequests);
        setCompletedAddUserActions(response.addRequests);
      }
    });

    // Cleanup
    return () => {
      window.removeEventListener("resize", setIsMobile(isMobileScreen()));
    };
  }, []);

  useEffect(() => {
    if (updatedRequest) {
      const requestId = updatedRequest.request.RequestId;
      let allRequests = [];

      if (updatedRequest.type === "remove") {
        allRequests = [...incompleteRemoveUserActions];
      } else if (updatedRequest.type === "add") {
        allRequests = [...incompleteAddUserActions];
      }

      allRequests = allRequests.filter((req) => req.RequestId !== requestId);
      allRequests.push(updatedRequest.request);

      if (updatedRequest.type === "remove") {
        setIncompleteRemoveUserActions(allRequests);
      } else if (updatedRequest.type === "add") {
        setIncompleteAddUserActions(allRequests);
      }
      setRequestIdBeingUpdated("");
    }
  }, [updatedRequest, incompleteAddUserActions, incompleteRemoveUserActions]);

  const getAllIncompleteUserRequests = () => {
    return incompleteRemoveUserActions.length + incompleteChangeUserActions.length + incompleteAddUserActions.length;
  };

  const getAllCompletedUserRequestsCount = () => {
    return completedRemoveUserActions.length + completedChangeUserActions.length + completedAddUserActions.length;
  };

  return (
    <MainContainer>
      <Notification />
      <div className={`d-flex ${incompleteUserActionsLoading || completedUserActionsLoading ? "" : "d-none"}`}>
        <div className="d-flex flex-row">
          <strong className="page-title" data-testid="bundle-heading">
            Request Status
          </strong>
        </div>
      </div>
      <div
        className={`d-flex justify-content-center ${
          incompleteUserActionsLoading || completedUserActionsLoading ? "" : "d-none"
        }`}
      >
        <div className={`mx-auto d-flex`}>
          <PuffLoader
            size={150}
            color={"#FFFFFF"}
            loading={incompleteUserActionsLoading || completedUserActionsLoading}
          />
        </div>
      </div>
      {!incompleteUserActionsLoading && !completedUserActionsLoading && (
        <>
          <div className="d-flex flex-row">
            <strong className="page-title" data-testid="bundle-heading">
              Request Status
            </strong>
          </div>
          <Accordion>
            <Card className="header-card my-2">
              <Accordion.Item id="accordionButton" eventKey={"incompleteAccordion"} className="base-accordion">
                <Accordion.Header as={Card.Header}>
                  <h5 className="report-card report-card-totals text-center">
                    Incomplete User Requests - {getAllIncompleteUserRequests()}
                  </h5>
                </Accordion.Header>
                <Accordion.Body>
                  <UserRequestsAccordion
                    type="incompleteRemove"
                    isMobile={isMobile}
                    userActions={incompleteRemoveUserActions}
                    setCurrentRequest={setCurrentRequest}
                    setShowModal={setShowIncompleteRemoveUserRequestsDetailsModal}
                    requestBeingUpdated={requestIdBeingUpdated}
                  />
                  <UserRequestsAccordion
                    type="incompleteChange"
                    isMobile={isMobile}
                    userActions={incompleteChangeUserActions}
                    setCurrentRequest={setCurrentRequest}
                    setShowModal={setShowIncompleteChangeUserRequestsDetailsModal}
                    requestBeingUpdated={requestIdBeingUpdated}
                  />
                  <UserRequestsAccordion
                    type="incompleteAdd"
                    isMobile={isMobile}
                    userActions={incompleteAddUserActions}
                    setCurrentRequest={setCurrentRequest}
                    setShowModal={setShowIncompleteAddUserRequestsDetailsModal}
                    requestBeingUpdated={requestIdBeingUpdated}
                  />
                </Accordion.Body>
              </Accordion.Item>
            </Card>
            <Card className="header-card my-2">
              <Accordion.Item id="accordionButton" eventKey={"completedAccordion"} className="base-accordion">
                <Accordion.Header as={Card.Header}>
                  <h5>Completed User Requests - {getAllCompletedUserRequestsCount()}</h5>
                </Accordion.Header>
                <Accordion.Body>
                  <UserRequestsAccordion
                    type="completedRemove"
                    isMobile={isMobile}
                    userActions={completedRemoveUserActions}
                    setCurrentRequest={setCurrentRequest}
                    setShowModal={setShowCompletedRemoveUserRequestsDetailsModal}
                  />
                  <UserRequestsAccordion
                    type="completedChange"
                    isMobile={isMobile}
                    userActions={completedChangeUserActions}
                    setCurrentRequest={setCurrentRequest}
                    setShowModal={setShowCompletedChangeUserRequestsDetailsModal}
                  />
                  <UserRequestsAccordion
                    type="completedAdd"
                    isMobile={isMobile}
                    userActions={completedAddUserActions}
                    setCurrentRequest={setCurrentRequest}
                    setShowModal={setShowCompletedAddUserRequestsDetailsModal}
                  />
                </Accordion.Body>
              </Accordion.Item>
            </Card>
          </Accordion>
        </>
      )}
      <RemoveRequestDetailsModal
        mode="incomplete"
        show={showIncompleteRemoveUserRequestsDetailsModal}
        onHide={() => setShowIncompleteRemoveUserRequestsDetailsModal(false)}
        request={currentRequest}
        //crmUser={crmUser}
        setUpdatedRequest={setUpdatedRequest}
        setRequestIdBeingUpdated={setRequestIdBeingUpdated}
      />
      <RemoveRequestDetailsModal
        mode="completed"
        show={showCompletedRemoveUserRequestsDetailsModal}
        onHide={() => setShowCompletedRemoveUserRequestsDetailsModal(false)}
        request={currentRequest}
        //crmUser={crmUser}
      />
      <UpdateRequestDetailsModal
        mode="incomplete"
        show={showIncompleteChangeUserRequestsDetailsModal}
        onHide={() => setShowIncompleteChangeUserRequestsDetailsModal(false)}
        request={currentRequest}
        //crmUser={crmUser}
        setUpdatedRequest={setUpdatedRequest}
        setRequestIdBeingUpdated={setRequestIdBeingUpdated}
      />
      <UpdateRequestDetailsModal
        mode="completed"
        show={showCompletedChangeUserRequestsDetailsModal}
        onHide={() => setShowCompletedChangeUserRequestsDetailsModal(false)}
        request={currentRequest}
        //crmUser={crmUser}
      />
      <AddUserRequestDetailsModal
        mode="incomplete"
        show={showIncompleteAddUserRequestsDetailsModal}
        onHide={() => setShowIncompleteAddUserRequestsDetailsModal(false)}
        request={currentRequest}
        //crmUser={crmUser}
        setUpdatedRequest={setUpdatedRequest}
        setRequestIdBeingUpdated={setRequestIdBeingUpdated}
      />
      <AddUserRequestDetailsModal
        mode="completed"
        show={showCompletedAddUserRequestsDetailsModal}
        onHide={() => setShowCompletedAddUserRequestsDetailsModal(false)}
        request={currentRequest}
        //crmUser={crmUser}
      />
    </MainContainer>
  );
};

export default RequestStatus;
